
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.383 2.722A1.733 1.733 0 0118.11 4.45v12.1a1.733 1.733 0 01-1.728 1.728h-12.1a1.733 1.733 0 01-1.727-1.729v-2.636c.152-.023.305-.11.457-.263l2.643-2.643 1.898 2.763.36.36c.361.361 1.082.361 1.442 0l2.739-3.603.722.72c.12.121.36.121.48.121s.36-.24.36-.36l.842-3.364c0-.18-.121-.36-.24-.48-.121-.12-.36-.12-.481-.12l-3.364.84c-.24 0-.36.12-.36.36 0 .122 0 .361.12.481l.841.84-2.5 3.244-2.259-3.123c-.192-.12-.48-.24-.72-.24-.241 0-.48.055-.744.295l-.337.306-1.322 1.322-.577.633V4.45a1.733 1.733 0 011.6-1.722l.127-.006h12.1z","fill":"currentColor"}})])
          )
        }
      }
    